import {
  getFeatureFlagsFromUser,
  isFeatureFlagEnabled,
} from "./featureFlags";

export type LibraryUser =
  | {
      schoolType?: string;
      featureFlags?: unknown;
    }
  | null
  | undefined;

/** Library is available to schools (worksheets) and churches (resources). */
export function librarySections(user: LibraryUser): {
  worksheets: boolean;
  resources: boolean;
} {
  const normalizedSchoolType =
    typeof user?.schoolType === "string"
      ? user.schoolType.toLowerCase().trim()
      : "";
  const aiEnabled = isFeatureFlagEnabled(getFeatureFlagsFromUser(user), "ai");
  return {
    worksheets:
      normalizedSchoolType === "school" && aiEnabled,
    resources:
      normalizedSchoolType === "church",
  };
}

/**
 * Primary route for the sidebar "Library" entry and related CTAs.
 * Matches `Library.tsx` hub visibility: schools → worksheets, churches → resources,
 * other organization types do not have Library access.
 */
export function getLibraryNavPath(user: LibraryUser): string {
  if (!user) {
    return "/library";
  }
  const normalizedSchoolType =
    typeof user.schoolType === "string"
      ? user.schoolType.toLowerCase().trim()
      : "";
  const isSchoolOrg = normalizedSchoolType === "school";
  const isChurchOrg = normalizedSchoolType === "church";
  const aiEnabled = isFeatureFlagEnabled(
    getFeatureFlagsFromUser(user),
    "ai",
  );

  if (isChurchOrg) {
    return "/resources";
  }
  if (isSchoolOrg && aiEnabled) {
    return "/create/worksheets";
  }
  return "/library";
}
